"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DragItem = DragItem;
exports.DragList = DragList;
var _Box = _interopRequireDefault(require("@mui/material/Box/Box.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/** react-beautiful-dnd DragDropContext and Droppable wrapper for simple, single list */
function DragList(props) {
  const {
    children,
    droppableContainerProps,
    droppableProps,
    items,
    onDragEnd,
    ...rest
  } = props;
  const handleDragEnd = ({
    source,
    destination
  }) => {
    // dropped outside the list
    if (!destination) return;
    const newItems = reorder(items, source.index, destination.index);
    onDragEnd(newItems);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: handleDragEnd,
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Droppable, {
      droppableId: "droppable",
      ...droppableProps,
      children: provided => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Box.default, {
        ...droppableContainerProps,
        ref: provided.innerRef,
        ...provided.droppableProps,
        children: [children, provided.placeholder]
      })
    })
  });
}
const useStyles = (0, _makeStyles.default)(({
  border,
  shadows
}) => ({
  item: {
    userSelect: 'none'
  },
  dragging: {
    border: border.default,
    boxShadow: shadows[2]
  }
}));
/** react-beautiful-dnd Draggable component wrapper */
function DragItem({
  itemId,
  index,
  children,
  ...rest
}) {
  const classes = useStyles();
  const dragId = typeof itemId === 'number' ? itemId.toString() : itemId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactBeautifulDnd.Draggable, {
    draggableId: dragId,
    index: index,
    ...rest,
    children: (provided, snapshot) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classnames.default)(classes.item, {
        [classes.dragging]: snapshot.isDragging
      }),
      style: provided.draggableProps.style,
      ref: provided.innerRef,
      ...provided.draggableProps,
      ...provided.dragHandleProps,
      children: children
    })
  });
}

/**  reorder the list */
function reorder(list, startIndex, endIndex) {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
}